<div class="modal-header border-0 pb-0">
  <h4 class="modal-title text-light-black fw-600" id="modal-title">
    <i class="fas fa-shield-alt text-primary me-2"></i>
    {{ label }}
  </h4>
  <button
    type="button"
    class="btn-close"
    aria-label="Close"
    (click)="cancel()"
  ></button>
</div>

<div class="modal-body py-4">
  <p *ngIf="message" class="text-light-black mb-3">{{ message }}</p>
  <p *ngIf="checkMessage" class="text-muted small mb-4">{{ checkMessage }}</p>

  <div class="otp-container">
    <div class="otp-inputs d-flex justify-content-center gap-2">
      <input
        #otpInput0
        type="text"
        class="form-control otp-input text-center"
        maxlength="1"
        [(ngModel)]="otp[0]"
        (input)="onInput($event, 0)"
        (keydown)="onKeyDown($event, 0)"
        (paste)="onPaste($event)"
        pattern="[0-9]"
        inputmode="numeric"
      />
      <input
        #otpInput1
        type="text"
        class="form-control otp-input text-center"
        maxlength="1"
        [(ngModel)]="otp[1]"
        (input)="onInput($event, 1)"
        (keydown)="onKeyDown($event, 1)"
        (paste)="onPaste($event)"
        pattern="[0-9]"
        inputmode="numeric"
      />
      <input
        #otpInput2
        type="text"
        class="form-control otp-input text-center"
        maxlength="1"
        [(ngModel)]="otp[2]"
        (input)="onInput($event, 2)"
        (keydown)="onKeyDown($event, 2)"
        (paste)="onPaste($event)"
        pattern="[0-9]"
        inputmode="numeric"
      />
      <input
        #otpInput3
        type="text"
        class="form-control otp-input text-center"
        maxlength="1"
        [(ngModel)]="otp[3]"
        (input)="onInput($event, 3)"
        (keydown)="onKeyDown($event, 3)"
        (paste)="onPaste($event)"
        pattern="[0-9]"
        inputmode="numeric"
      />
      <input
        #otpInput4
        type="text"
        class="form-control otp-input text-center"
        maxlength="1"
        [(ngModel)]="otp[4]"
        (input)="onInput($event, 4)"
        (keydown)="onKeyDown($event, 4)"
        (paste)="onPaste($event)"
        pattern="[0-9]"
        inputmode="numeric"
      />
      <input
        #otpInput5
        type="text"
        class="form-control otp-input text-center"
        maxlength="1"
        [(ngModel)]="otp[5]"
        (input)="onInput($event, 5)"
        (keydown)="onKeyDown($event, 5)"
        (paste)="onPaste($event)"
        pattern="[0-9]"
        inputmode="numeric"
      />
    </div>
  </div>
</div>

<div class="modal-footer border-0 pt-0">
  <button
    type="button"
    class="btn btn-secondary fw-600"
    (click)="cancel()"
  >
    Cancel
  </button>
  <button
    type="button"
    class="btn btn-primary fw-600 ms-2"
    [disabled]="otp.join('').length !== 6"
    (click)="confirm()"
    style="background-color: hsl(0.41deg, 75.51%, 38.43%); border-color: hsl(0.41deg, 75.51%, 38.43%);"
  >
    Confirm
  </button>
</div>

